import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import Modal from 'react-modal';
import classNames from 'classnames';

import * as actions from '../../actions';
import * as _actionsJourney2 from '../../actions/journey2';
import * as _actionsBasket from '../../actions/basket';
import * as _actionsProduct from '../../actions/product';
import * as _actionsFilters from '../../actions/filters';
import { RootState } from '../../reducers';
import './AgencyCheckout.scss';
import BreadCrumbs from '../../components/BreadCrumbs';
import Summary from '../Summary';
import SpinnerV2 from '../../components/SpinnerV2';
import Basket from '../../components/Basket';
import { ModalContainer } from '../../components/ModalContainer';
import { ServiceDesk } from '../../components/ServiceDesk';
import { LoginRequired } from '../../components/ProtectedComponent';
import ErrorContainer from '../../components/ErrorContainer/ErrorContainer';
import { SchemaProduct } from '@repo/legacy-commerce-api';
import { PartiallyIntegratedUserDataEC } from '../../reducers/app';

Modal.setAppElement('#root');

interface Props {
  actions: any;
  actionsJourney2: typeof _actionsJourney2;
  actionsBasket: typeof _actionsBasket;
  actionsProduct: typeof _actionsProduct;
  actionsFilters: typeof _actionsFilters;
  intl: any;
  keycloakReady: boolean;
  loading: { general: boolean; mapProduct?: boolean };
  location: any;
  product: any;
  productsJ2: SchemaProduct[];
  userDataEC: PartiallyIntegratedUserDataEC;
  errors: any;
  productsJ2ByUrn: Record<string, SchemaProduct>;
}

const AgencyCheckout = (props: Props) => {
  const { location, keycloakReady, userDataEC, intl } = props;

  useEffect(() => {
    preFetchData();
  }, []);

  const preFetchData = () => {
    let extraParam = null;
    if (props.userDataEC.basketInfo) {
      extraParam = {
        basket: props.userDataEC.basketInfo?.basket,
        basketreference: props.userDataEC.basketInfo?.basketreference,
      };
    }
    props.actionsFilters.fetchIndustries({ context: 'alcohol', ...extraParam });
    props.actionsFilters.fetchIndustries({ context: 'big5', ...extraParam });
  };

  return (
    <>
      <BreadCrumbs
        parentPage={
          <a
            className='color-text pointer'
            href={intl.formatMessage({
              id: 'ec.navigation.parentPlanningAndBookingLink',
              defaultMessage: 'https://www.apgsga.ch/de/aussenwerbung/plakate-online-buchen/',
            })}
          >
            {intl.formatMessage({
              id: 'ec.navigation.planenbuchen',
              defaultMessage: 'Planen und Buchen',
            })}
          </a>
        }
        pageName={intl.formatMessage({
          id: 'ec.navigation.journey2PageName',
          defaultMessage: 'Gezielte Werbeflächen auswählen',
        })}
      />

      <ErrorContainer journeyType='dashboard' />

      <div className={classNames('container-fluid overflow-hidden agencyCheckout p-0')} id='agencyCheckout'>
        <div className={classNames('pageContainer')}>
          <Basket
            products={props.userDataEC?.basketProducts?.productsByUrnDate || []}
            total={props.userDataEC?.basketProducts?.stats?.mediasum || 0}
          />

          <ModalContainer
            actionsBasket={_actionsBasket}
            location={location}
            actionsJourney2={_actionsJourney2}
            userDataEC={props.userDataEC}
            actionsProduct={_actionsProduct}
            errors={props.errors}
            intl={props.intl}
            loading={props.loading}
            product={props.product}
            productsJ2={props.productsJ2}
            productsJ2ByUrn={props.productsJ2ByUrn}
          />

          <div className='contentContainer'>
            <div className={classNames('main bg-transparent p-0')}>
              {keycloakReady && userDataEC ? (
                <LoginRequired component={<Summary isAgencyCheckout />} />
              ) : (
                <SpinnerV2 relative fullScreen />
              )}
            </div>
          </div>
        </div>
      </div>

      <ServiceDesk intl={intl} />
    </>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    actions: bindActionCreators(actions as any, dispatch),
    dispatch: dispatch,
    actionsJourney2: bindActionCreators(_actionsJourney2 as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    actionsProduct: bindActionCreators(_actionsProduct as any, dispatch),
    actionsFilters: bindActionCreators(_actionsFilters as any, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AgencyCheckout);
